<template>
  <md-dialog :md-active.sync="showTagDialog" id="tag-dialog">
    <md-dialog-title>Available Customer Tags</md-dialog-title>
    <div class="md-layout">
      <div id="tag-body" class="md-layout-item md-size-100">
        <div class="md-chips md-success">
          <md-chip
            @click="selectTag(tag)"
            md-clickable
            v-for="tag in availableTags"
            :key="tag.id"
            >{{ tag.name }}</md-chip
          >
        </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary md-dense" @click="close">Close</md-button>
      </md-dialog-actions>
    </div>
  </md-dialog>
</template>

<script>
export default {
  props: {
    showTagDialog: {
      type: Boolean,
      default: false
    },
    availableTags: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  methods: {
    selectTag(tag) {
      this.$emit("tagSelected", tag);
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
#tag-dialog {
  &::v-deep .md-dialog-container {
    max-width: 500px;
    min-width: 500px;
    width: 500px;
  }
}
#tag-body {
  padding: 30px;

  &::v-deep .md-chip {
    .md-ripple {
      font-weight: inherit;
      font-size: inherit;
      text-transform: none;
    }
  }
}
</style>
